// extracted by mini-css-extract-plugin
module.exports = {"Theme":"light_Theme__3XUtO"};